import React, { useEffect, useRef, useState } from "react";
import { useMutation } from "@apollo/client";
import { css } from "glamor";
import { Button } from "../../components/Button";
import { showGlobalLoader, hideGlobalLoader } from "../../lib/loaderController";
import { updateFeatureFacilityProviderConfigurationMutation } from "../Settings/RateCards/queries";

export default function MewsIntegrationToggle({ config }) {
    const mounted = useRef(true);
    const [enabled, setEnabled] = useState(config.configuration?.enabled === true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(false);
    const [updateConfiguration] = useMutation(updateFeatureFacilityProviderConfigurationMutation, {
        errorPolicy: 'all',
    });

    useEffect(() => {
        return () => { mounted.current = false; };
    }, []);

    useEffect(() => {
        setEnabled(config.configuration?.enabled === true);
        setError(false);
    }, [config.configuration?.enabled]);

    async function toggle() {
        if (saving) return;
        const nextEnabled = !enabled;
        setSaving(true);
        setError(false);
        showGlobalLoader();
        try {
            const result = await updateConfiguration({
                variables: {
                    id: config.id,
                    configuration: { ...config.configuration, enabled: nextEnabled },
                },
            });
            if (!mounted.current) return;
            if (result.errors?.length) {
                setError(true);
                return;
            }
            setEnabled(nextEnabled);
        } catch {
            if (mounted.current) setError(true);
        } finally {
            if (mounted.current) setSaving(false);
            hideGlobalLoader();
        }
    }

    return (
        <>
            <Button onClick={toggle} disabled={saving} className={css({ marginRight: '1rem' })}>
                {enabled ? 'Disable MEWS' : 'Enable MEWS'}
            </Button>
            {error && (
                <span role="alert" className={css({ color: '#c62828', marginRight: '1rem' })}>
                    An error occurred while updating MEWS integration. Please try again.
                </span>
            )}
        </>
    );
}
